<template>
  <BasicList
      :data="user.attributes.roles"
      :headlines="headlines"
      :can-show="() => false"
      :can-destroy="() => hasPermission('admin')"
      :checkbox-column-width="2"
      :button-column-width="2"
      :selected.sync="selected"
      @destroy="destroy"
  >
    <template v-slot:default="{ row: role }">
      <td>
        {{ role.name }}
      </td>
    </template>

    <template v-slot:modals>
      <CreateModal :user="user" @created="$emit('input', $event)"/>
    </template>
  </BasicList>
</template>

<script>
import http from '../../../../http'
import modal from '../../../../modal'
import notify from '../../../../notify'
import store from '../../../../store'
import BasicList from '../../../Panels/Lists/Basic'
import Permissions from '../../../../mixins/Permissions'
import CreateModal from '@/components/Administration/UserRoles/Modals/Create'

export default {
  components: {BasicList, CreateModal},

  mixins: [Permissions],

  model: {
    prop: 'user'
  },

  props: {
    user: {
      required: true
    }
  },

  data() {
    return {
      selected: [],

      shared: store
    }
  },

  computed: {
    headlines() {
      return [
        {width: 20, text: 'Role'},
      ]
    },
  },

  methods: {
    destroy(role) {
      modal.confirm('Are you sure that you want to remove the role?', () => {
        http.delete('/api/v2/users/' + this.user.id + '/roles/' + role.id).then(response => {
          notify.success('The role was removed')

          this.$emit('input', response.data.data)
        })
      })
    },
  }
}
</script>
